/* eslint-disable no-param-reassign */
import { CaseReducer, SliceCaseReducers } from '@reduxjs/toolkit';
import { createSlice } from 'helpers/createSlice';
import { ActionWithPayload, MakerSelectors } from 'types';

interface Options {
  onAfterSuccess?: () => void;
}

interface StateId {
  id: string;
  options?: Options;
}

type State = Array<StateId>;

interface Reducers extends SliceCaseReducers<State> {
  pushId: CaseReducer<State, ActionWithPayload<StateId>>;
  removeId: CaseReducer<State, ActionWithPayload<string>>;
}

interface ExtraSelectors extends MakerSelectors<State> {
  getIdState: (state: State) => (id?: string) => StateId | undefined;
}

const initialState: State = [];

export const updateContent = createSlice<State, Reducers, ExtraSelectors>({
  name: 'updateContent',
  initialState,
  reducers: {
    pushId: (state, { payload }) => {
      state.push(payload);
    },
    removeId: (state, { payload }) => state?.filter(({ id }) => id !== payload),
  },
  extraSelectors: {
    getIdState: (state) => (thisId) => state.find(({ id }) => id === thisId),
  },
});
